import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logoLight from '../../../Assets/Images/seekjob/light.png';
import { newsletter_subscription } from "../../../Services/Student/StudentApi";

const CareerFooter = ({ theme = 'light' }) => {
  const isDark = theme === 'dark';
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const sections = {
    Company: ['Home', 'About Us', 'Features', 'Terms of Service', 'Privacy Policy'],
    'Career Centers': ['Resources', 'Blogs', 'Request Demo'],
    'Job Seekers': ['How It Works', 'Resume Enhancer', 'Sign Up', 'Blogs'],
    Employers: ['Solutions', 'Blogs', 'Request Demo'],
  };

  const socialIcons = [
    {
      src: !isDark ? 'images/Vector (1).svg' : 'images/instagram0.svg',
      alt: 'Instagram',
      href: 'https://www.instagram.com/seekjobs.ai/',
    },
    {
      src: !isDark ? 'images/twitter.png' : 'images/clip-path-group0.svg',
      alt: 'Twitter',
      href: '#',
    },
    {
      src: !isDark ? 'images/linkedin (2).svg' : 'images/providers-list0.svg',
      alt: 'LinkedIn',
      href: 'https://www.linkedin.com/company/seekjobs-ai',
    },
    {
      src: !isDark ? 'images/tiktok.png' : 'images/tiktok0.svg',
      alt: 'TikTok',
      href: '#',
    },
  ];

  // 🔗 Section-aware routing
  const handleNavigation = (section, linkText) => {
    const routeMap = {
      Company: {
        Home: '/',
        'About Us': '/about-us',
        Features: '/features',
        'Terms of Service': '/terms-of-service',
        'Privacy Policy': '/privacy-policy',
      },
      'Career Centers': {
        Resources: '/career-centers',
        Blogs: '',
        'Request Demo': '/career-centers#ContactUs',
      },
      'Job Seekers': {
        'How It Works': '/#SeeItIn',
        'Resume Enhancer': '/features#resumeEnhancer',
        'Sign Up': '/sign-up',
        Blogs: '',
      },
      Employers: {
        Solutions: '/employer#TopCompany',
        Blogs: '',
        'Request Demo': '/employer#ContactUs',
      },
    };

    const sectionMap = routeMap[section] || {};
    const path = sectionMap[linkText];

    if (path) {
      if (linkText === 'Terms of Service' || linkText === 'Privacy Policy') {
        window.open(path, '_blank', 'noopener noreferrer');
      } else {
        navigate(path);
      }
    }
  };
  const [statusMessage, setStatusMessage] = useState({
    show: false,
    type: '', // 'success' or 'error'
    text: '',
  });
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handleSubscribe = async () => {
    if (email && !/\S+@\S+\.\S+/.test(email)) {
      setStatusMessage({
        show: true,
        type: 'Error',
        text: `Please enter a valid email address.`,
      })

      return;
    }
    if (!email) {
      setStatusMessage({
        show: true,
        type: 'Error',
        text: `Email field cannot be empty.`,
      })

      return;
    }
    if (email) {
      setStatusMessage({
        show: true,
        type: 'success',
        text: 'Subscribed successfully!',
      });
      await newsletter_subscription({ email })
      setEmail('');
    }
  };
  return (
    <div
      className={`tw-px-4 tw-pt-20 tw-pb-10 ${isDark ? 'tw-bg-transparent tw-text-white' : 'tw-bg-white tw-text-black'}`}
      style={
        !isDark
          ? {
            backgroundImage: `radial-gradient(rgba(126, 130, 153, 0.6) 1px, transparent 1px)`,
            backgroundSize: `30px 30px`,
            backgroundColor: '#ffffffff',
          }
          : undefined
      }
    >
      <div className="tw-container tw-mx-auto ">
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-8">
          {/* Left: Logo + Social Icons */}
          <div className="md:tw-col-span-4">
            <div onClick={() => navigate('/')} className="tw-flex tw-flex-col tw-justify-between tw-h-full tw-min-h-[200px]">
              {isDark ? (

                <img src="images/logo/Logo1.png" alt="SeekJobs Background" className="md:tw-w-[13rem] tw-w-[25rem] md:tw-h-[3rem] tw-h-[6rem]" />


              ) : (
                <img src={logoLight} alt="SeekJobs Logo" className="md:tw-w-[13rem] tw-w-[25rem] md:tw-h-[3rem] tw-h-[6rem]" />
              )}

              {/* Social Icons */}
              <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-pt-8">
                <span className="tw-text-sm md:tw-w-full">Follow Us On:</span>
                {socialIcons.map((icon, i) => (
                  <a key={i} href={icon.href} target="_blank" rel="noopener noreferrer">
                    <img src={icon.src} alt={icon.alt} className="tw-w-[25px] tw-h-[25px]" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Subscribe + Links */}
          <div className="md:tw-col-span-8 tw-flex tw-flex-col tw-gap-6">
            {/* Subscribe */}
            <div>
              <div className="tw-flex tw-justify-center md:tw-justify-end">
                <div className="tw-w-full tw-max-w-[575px]">
                  <p className="tw-text-[16px] tw-mb-2">Get career hacks and job market insights dropped straight to your inbox</p>
                  <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-2">
                    <input
                      type="email"
                      value={email}
                      onChange={handleEmailChange}
                      placeholder="Your Email Address"
                      className={`tw-py-2 tw-px-4 tw-rounded-[10px] tw-w-full ${isDark ? 'tw-text-black' : 'tw-bg-white tw-text-black'}`}
                    />
                    <button onClick={() => handleSubscribe()} className="tw-bg-[#3E97FF] tw-text-white tw-py-2 tw-px-4 tw-rounded-[10px] tw-flex tw-items-center tw-border-[#3E97FF] tw-gap-2">
                      <img src="images/notification0.svg" alt="Notify" className="tw-w-4" />
                      Subscribe
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Links */}
            <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-text-nowrap tw-gap-y-8 tw-gap-x-[4rem]">
              {Object.entries(sections).map(([heading, links]) => (
                <div key={heading} className="tw-text-left">
                  <h5 className={`tw-font-semibold tw-mb-4 tw-text-[16px] ${isDark ? 'tw-text-gray-300' : 'tw-text-[#7E8299]'}`}>
                    {heading}
                  </h5>
                  <ul className="tw-space-y-6">
                    {links.map(link => (
                      <li
                        key={link}
                        onClick={() => handleNavigation(heading, link)}
                        className="tw-text-[14px] hover:tw-underline cursor-pointer tw-font-semibold"
                      >
                        {link}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {statusMessage.show && (
        <div className="tw-fixed tw-inset-0 tw-bg-black/40 tw-flex tw-items-center tw-justify-center tw-z-50">
          <div className="tw-bg-white tw-rounded-lg tw-shadow-lg tw-p-6 tw-max-w-md tw-w-full tw-text-center">
            <h2
              className={`tw-text-lg tw-font-semibold ${statusMessage.type === 'success'
                ? 'tw-text-green-600'
                : 'tw-text-red-600'
                }`}
            >
              {statusMessage.type === 'success' ? 'Success' : 'Error'}
            </h2>
            <p className="tw-mt-2 tw-text-sm tw-text-gray-700">{statusMessage.text}</p>
            <button
              className="tw-mt-4 tw-px-4 tw-py-2 tw-bg-[#0843FE] tw-border-none tw-text-white tw-rounded hover:tw-bg-blue-700"
              onClick={() => setStatusMessage({ show: false, type: '', text: '' })}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CareerFooter;
